export var UserFlagKeys;
(function (UserFlagKeys) {
    UserFlagKeys["attendanceTutorialComplete"] = "attendanceTutorialComplete";
    UserFlagKeys["programmeWalkthroughComplete"] = "programmeWalkthroughComplete";
    UserFlagKeys["incomeStatementsWalkthroughComplete"] = "incomeStatementsWalkthroughComplete";
    UserFlagKeys["communityWalkthroughComplete"] = "communityWalkthroughComplete";
})(UserFlagKeys || (UserFlagKeys = {}));
export const programmePlanningPromptKey = (reportPeriodId) => `programmePlanningPrompt:${reportPeriodId}`;
//# sourceMappingURL=user-flag-keys.js.map